<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="oauth/client">
      <template slot="toolbar">
        <el-button type="primary" size="mini" @click="$refs.editOauthClient.open()">
          新建
        </el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户端ID">
            <el-input v-model.trim="filter.clientId" placeholder="请输入" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="clientId" label="客户端ID" width="200"/>
      <el-table-column prop="userName" label="关联用户" width="120">
        <template slot-scope="scope">
          <span>{{scope.row.userName || scope.row.systemUserId}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="expireDays" label="有效期(天)" width="100" align="center"/>
      <el-table-column prop="isActive" label="是否启用" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive === 1 ? 'success' : 'info'">
            {{scope.row.isActive === 1 ? "启用" : "禁用"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip/>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="220px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="$refs.editOauthClient.open(scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="resetSecret(scope.row)">重置密钥</el-button>
          <el-button size="mini" type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <oauth-client-edit ref="editOauthClient" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import OauthClientEdit from "@/views/SystemInfo/OauthClient/OauthClientEdit";

  export default {
    name: "OauthClientList",
    components: {VmTable, VmSearch, OauthClientEdit},
    data() {
      return {
        filter: {
          clientId: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNo) {
        this.$refs.vmTable.getList(pageNo);
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          const id = row.id || row.pkid;
          this.$http
              .delete("basic", "oauth/client", id)
              .then(() => {
                this.$message.success("删除成功");
                this.getList(1);
              });
        });
      },
      resetSecret(row) {
        this.$confirm("确定重置密钥吗?", "提示", {type: "warning"}).then(() => {
          const id = row.id || row.pkid;
          this.$http.post("basic", `oauth/client/${id}/resetSecret`)
              .then(resp => {
                const secret = resp && resp.plainSecret !== undefined && resp.plainSecret !== null ? resp.plainSecret : resp;
                if (secret) {
                  this.$message.success(`重置成功，新密钥：${secret}`);
                } else {
                  this.$message.success("重置成功");
                }
              });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
